
// 公司主体
const COMPANY_LIST = 'COMPANY_LIST'
// 供应商管理
const SUPPLIER_MANAGE_LIST = 'SUPPLIER_MANAGE_LIST'
// 库存组织
const INVENTORY_ORGANIZATION_LIST = 'INVENTORY_ORGANIZATION_LIST'
// 仓库
const WAREHOUSE_LIST = 'WAREHOUSE_LIST'
// 单位
const UNIT_LIST = 'UNIT_LIST'
// 标准单位转换
const STANDARD_UNIT_LIST = 'STANDARD_UNIT_LIST'
// 分类单位转换
const CLASSIFICATION_UNIT_LIST = 'CLASSIFICATION_UNIT_LIST'
// 物料类别
const MATERIAL_CATEGORY_LIST = 'MATERIAL_CATEGORY_LIST'
// 物料模板
const MATERIAL_TEMPLATE_LIST = 'MATERIAL_TEMPLATE_LIST'
// 物料清单
const MATERIAL_INVENTORY_LIST = 'MATERIAL_INVENTORY_LIST'
// 成品属性维护
const PRODUCT_ATTRIBUTES_LIST = 'PRODUCT_ATTRIBUTES_LIST'
// 原材料属性维护
const MATERIAL_PROPERTY_LIST = 'MATERIAL_PROPERTY_LIST'
// 生产属性维护
const PRODUCTION_ATTRIBUTES_LIST = 'PRODUCTION_ATTRIBUTES_LIST'
// 主计划属性维护
const MAIN_PLAN_ATTRIBUTE_LIST = 'MAIN_PLAN_ATTRIBUTE_LIST'
// 发货预测基础数据
const SHIPMENT_FORECAST_SETTINGS_LIST = 'SHIPMENT_FORECAST_SETTINGS_LIST'
// 供应商产能
const SUPPLIER_CAPACITY_LIST = 'SUPPLIER_CAPACITY_LIST'
// 安全库存类别查询
const SECURITY_TYPE_QUERY_LIST = 'SECURITY_TYPE_QUERY_LIST'
// 安全库存比例
const SAFETY_STOCK_RATIO_LIST = 'SAFETY_STOCK_RATIO_LIST'
// 销售预测
const SALES_FORECAST_WORK_DESK_LIST = 'SALES_FORECAST_WORK_DESK_LIST'
// 新品预测
const NEW_PRODUCT_FORECAST_WORKDESK_LIST = 'NEW_PRODUCT_FORECAST_WORKDESK_LIST'
// 预测缺失
const MISSING_FORECAST_LIST = 'MISSING_FORECAST_LIST'
// 零星预测
const SPORADIC_FORECAST_LIST = 'SPORADIC_FORECAST_LIST'
// 零星需求
const SPORADIC_DEMAND_LIST = 'SPORADIC_DEMAND_LIST'
// 审核
const REQUIREMENT_APPROVAL_LIST = 'REQUIREMENT_APPROVAL_LIST'
// 供应列表—默认值
const SUPPLY_INFO_LIST = 'SUPPLY_INFO_LIST'
// 发货预测工作台
const SHIPMENT_FORECAST_MANAGEMENT_LIST = 'SHIPMENT_FORECAST_MANAGEMENT_LIST'
// 月度计划
const MONTHLY_PLAN_LIST = 'MONTHLY_PLAN_LIST'
// MPS基础数据
const BASIC_INFO_INDEX_LIST = 'BASIC_INFO_INDEX_LIST'
// 标准分配比例-默认值
const PRODUCT_DISTRIBUTION_RATIO_LIST = 'PRODUCT_DISTRIBUTION_RATIO_LIST'
// 标准分配比例
const PRODUCT_SOURCE_RULES_LIST = 'PRODUCT_SOURCE_RULES_LIST'
// 选项
const MPS_OPTION_LIST = 'MPS_OPTION_LIST'
// 工作台
const MPS_WORK_DESK_LIST = 'MPS_WORK_DESK_LIST'
// 供应商订单明细
const MPS_SUPPLY_DETAILS_LIST = 'MPS_SUPPLY_DETAILS_LIST'
// 计划单发放
const MPS_PLAN_EXECUTION_LIST = 'MPS_PLAN_EXECUTION_LIST'
// 例外明细
const MPS_EXCEPTION_DETAILS_LIST = 'MPS_EXCEPTION_DETAILS_LIST'
// 计划参数
const PLAN_PARAMETERS_LIST = 'PLAN_PARAMETERS_LIST'
// MRP计划名称
const MRP_PLAN_NAME_LIST = 'MRP_PLAN_NAME_LIST'
// MDS/MPS名称
const DMS_MPS_NAME_LIST = 'DMS_MPS_NAME_LIST'
// 计划运行列表
const CALL_MATERIAL_PLAN_LIST = 'CALL_MATERIAL_PLAN_LIST'
// 叫料单管理
const CALL_MATERIAL_MANAGE_LIST = 'CALL_MATERIAL_MANAGE_LIST'
// 工单齐套报表
const WORK_ORDER_SET_REPORT_LIST = 'WORK_ORDER_SET_REPORT_LIST'
// 工单物料齐套报表
const MATERIAL_SET_REPORT_LIST = 'MATERIAL_SET_REPORT_LIST'
// 安全库存系数
const SAFETY_STOCK_COEFFICIENT_LIST = 'SAFETY_STOCK_COEFFICIENT_LIST'
// 差异率系数设置
const DIFFERENCE_RATE_COEFFICIENT_LIST = 'DIFFERENCE_RATE_COEFFICIENT_LIST'
// 计划版本
const PLAN_EXCEPTION_INFORMATION_LIST = 'PLAN_EXCEPTION_INFORMATION_LIST'
// BOM组件
const BOM_ASSEMBLY_LIST = 'BOM_ASSEMBLY_LIST'
// 物料使用处
const MATTER_USE_PLACE_LIST = 'MATTER_USE_PLACE_LIST'
// 物料来源
const MATTER_SOURCE_LIST = 'MATTER_SOURCE_LIST'
// 供应需求
const SUPPLY_DEMAND_LIST = 'SUPPLY_DEMAND_LIST'
// 计划例外查询
const PLAN_EXCEPTION_QUERY_LIST = 'PLAN_EXCEPTION_QUERY_LIST'
// MDS/MPS条目
const DMS_MPS_ITEM_LIST = 'DMS_MPS_ITEM_LIST'
// 要货计划查询/发布
const FOR_GOODS_PLAN_LIST = 'FOR_GOODS_PLAN_LIST'
// 要货单管理
const FOR_GOODS_MANAGE_LIST = 'FOR_GOODS_MANAGE_LIST'
// 日生产计划成品
const END_PRODUCT_LIST = 'END_PRODUCT_LIST'
// 日生产计划零件
const PARTS_PRODUCT_LIST = 'PARTS_PRODUCT_LIST'
// 供应商关系
const SUPPLIER_RELATIONSHIP_LIST = 'SUPPLIER_RELATIONSHIP_LIST'
// 工单分类
const JOB_CLASS_LIST = 'JOB_CLASS_LIST'
// 车间
const FACTORY_ASSEMBLY_LIST = 'FACTORY_ASSEMBLY_LIST'
// 工序
const PRODUCTION_PROCESSES_LIST = 'PRODUCTION_PROCESSES_LIST'
// 标准工艺路线
const STANDARD_PROCESS_LIST = 'STANDARD_PROCESS_LIST'
// 产线
const PRODUCTION_LINE_LIST = 'PRODUCTION_LINE_LIST'
// 产品产线
const PRODUCT_PRODUCTION_LINE_LIST = 'PRODUCT_PRODUCTION_LINE_LIST'
// 生产异常记录
const ANOMALY_RECORD_LIST = 'ANOMALY_RECORD_LIST'
// 工作日历
const WORK_CALENDAR_LIST = 'WORK_CALENDAR_LIST'
// 班次信息
const FREQUENCY_INFORMATION_LIST = 'FREQUENCY_INFORMATION_LIST'
// 零部件送货
const PARTS_DELIVERY_LIST = 'PARTS_DELIVERY_LIST'
// 组装中心收货
const ASSEMBLY_RECEIVING_GOODS_LIST = 'ASSEMBLY_RECEIVING_GOODS_LIST'
// 分仓入库计划
const WAREHOUSE_ALLOCATION_PLAN_LIST = 'WAREHOUSE_ALLOCATION_PLAN_LIST'
// 调拨计划
const ALLOCATION_PLAN_LIST = 'ALLOCATION_PLAN_LIST'
// 总控计划工作台
const MASTER_CONTROL_PLAN_LIST = 'MASTER_CONTROL_PLAN_LIST'
// 入库执行报表
const INBOUND_EXECUTION_REPORT_LIST = 'INBOUND_EXECUTION_REPORT_LIST'
// 不满足汇总
const UNSATISFACTORY_RECEIVING_LIST = 'UNSATISFACTORY_RECEIVING_LIST'
// 不满足明细
const UNSATISFACTORY_RECEIVING_DETAIL_LIST = 'UNSATISFACTORY_RECEIVING_DETAIL_LIST'
// 作业能力
const WORK_CAPACITY_LIST = 'WORK_CAPACITY_LIST'
// 审批流程
const APPROVAL_PROCESS_LIST = 'APPROVAL_PROCESS_LIST'
// 库存余额报表
const STOCK_ATOM_REPORT_LIST = 'STOCK_ATOM_REPORT_LIST'
// 计划达交率报表
const PLAN_DELIVERY_RATE_LIST = 'PLAN_DELIVERY_RATE_LIST'
// 成品出库及时率
const FINISHED_PRODUCTS_DELIVERY_RATE_LIST = 'FINISHED_PRODUCTS_DELIVERY_RATE_LIST'
// 组装中心缺料报表
const MATERIAL_SHORTAGE_ASSEMBLY_CENTER_LIST = 'MATERIAL_SHORTAGE_ASSEMBLY_CENTER_LIST'
// 叫料材料报表
const MANUAL_CALL_MATERIAL_LIST = 'MANUAL_CALL_MATERIAL_LIST'
// 原材料达交率报表
const RAW_MATERIAL_DELIVERY_RATE_LIST = 'RAW_MATERIAL_DELIVERY_RATE_LIST'
// 产业园出库明细账
const OUTBOUND_DETAILS_LIST = 'OUTBOUND_DETAILS_LIST'
// 月计划单池
const MONTH_PLAN_POOL_LIST = 'MONTH_PLAN_POOL_LIST'
// 产业园入库明细账
const INVENTORY_DETAILS_LIST = 'INVENTORY_DETAILS_LIST'
// 每日分析报表
const ESTATE_DAILY_PLAN_ANALYSIS_REPORT_LIST = 'ESTATE_DAILY_PLAN_ANALYSIS_REPORT_LIST'
// 库存余额拆分表
const INVENTORY_BALANCE_SPLIT_LIST = 'INVENTORY_BALANCE_SPLIT_LIST'
// 计划单池订单表
const PLAN_POOL_REPORT_LIST = 'PLAN_POOL_REPORT_LIST'
// 用户管理
const USER_LIST = 'USER_LIST'
// 岗位管理
const POST_LIST = 'POST_LIST'
// 角色管理
const ROLE_LIST = 'ROLE_LIST'
// 业务组织
const BUSINESS_ORGANIZATION_LIST = 'BUSINESS_ORGANIZATION_LIST'
// 参数设置
const CONFIG_LIST = 'CONFIG_LIST'
// 通知公告
const NOTICE_LIST = 'NOTICE_LIST'
// 字典管理
const DICT_LIST = 'DICT_LIST'
// 快码管理
const LOOKUP_LIST = 'LOOKUP_LIST'
// 编码配置
const CODE_CONFIG_LIST = 'CODE_CONFIG_LIST'
// 操作日志
const OPERATION_LOG_LIST = 'OPERATION_LOG_LIST'
// 登录日志
const LOGIN_INFOR_LIST = 'LOGIN_INFOR_LIST'
// MQ日志
const RMS_MQ_LOG_LIST = 'RMS_MQ_LOG_LIST'
// 在线用户
const ONLINE_LIST = 'ONLINE_LIST'
// 代码生成
const GEN_LIST = 'GEN_LIST'
// 裁床成本分析报表
const CUTTING_BED_COST_ANALYSIS_REPORT_LIST = 'CUTTING_BED_COST_ANALYSIS_REPORT_LIST'

export default {
  COMPANY_LIST,
  SUPPLIER_MANAGE_LIST,
  INVENTORY_ORGANIZATION_LIST,
  WAREHOUSE_LIST,
  UNIT_LIST,
  STANDARD_UNIT_LIST,
  CLASSIFICATION_UNIT_LIST,
  MATERIAL_CATEGORY_LIST,
  MATERIAL_TEMPLATE_LIST,
  MATERIAL_INVENTORY_LIST,
  PRODUCT_ATTRIBUTES_LIST,
  MATERIAL_PROPERTY_LIST,
  PRODUCTION_ATTRIBUTES_LIST,
  MAIN_PLAN_ATTRIBUTE_LIST,
  SHIPMENT_FORECAST_SETTINGS_LIST,
  SUPPLIER_CAPACITY_LIST,
  SECURITY_TYPE_QUERY_LIST,
  SAFETY_STOCK_RATIO_LIST,
  SALES_FORECAST_WORK_DESK_LIST,
  NEW_PRODUCT_FORECAST_WORKDESK_LIST,
  MISSING_FORECAST_LIST,
  SPORADIC_FORECAST_LIST,
  SPORADIC_DEMAND_LIST,
  REQUIREMENT_APPROVAL_LIST,
  SUPPLY_INFO_LIST,
  SHIPMENT_FORECAST_MANAGEMENT_LIST,
  MONTHLY_PLAN_LIST,
  BASIC_INFO_INDEX_LIST,
  PRODUCT_DISTRIBUTION_RATIO_LIST,
  PRODUCT_SOURCE_RULES_LIST,
  MPS_OPTION_LIST,
  MPS_WORK_DESK_LIST,
  MPS_SUPPLY_DETAILS_LIST,
  MPS_PLAN_EXECUTION_LIST,
  MPS_EXCEPTION_DETAILS_LIST,
  PLAN_PARAMETERS_LIST,
  MRP_PLAN_NAME_LIST,
  DMS_MPS_NAME_LIST,
  CALL_MATERIAL_PLAN_LIST,
  CALL_MATERIAL_MANAGE_LIST,
  WORK_ORDER_SET_REPORT_LIST,
  MATERIAL_SET_REPORT_LIST,
  SAFETY_STOCK_COEFFICIENT_LIST,
  DIFFERENCE_RATE_COEFFICIENT_LIST,
  PLAN_EXCEPTION_INFORMATION_LIST,
  BOM_ASSEMBLY_LIST,
  MATTER_USE_PLACE_LIST,
  MATTER_SOURCE_LIST,
  SUPPLY_DEMAND_LIST,
  PLAN_EXCEPTION_QUERY_LIST,
  DMS_MPS_ITEM_LIST,
  FOR_GOODS_PLAN_LIST,
  FOR_GOODS_MANAGE_LIST,
  END_PRODUCT_LIST,
  PARTS_PRODUCT_LIST,
  SUPPLIER_RELATIONSHIP_LIST,
  JOB_CLASS_LIST,
  FACTORY_ASSEMBLY_LIST,
  PRODUCTION_PROCESSES_LIST,
  STANDARD_PROCESS_LIST,
  PRODUCTION_LINE_LIST,
  PRODUCT_PRODUCTION_LINE_LIST,
  ANOMALY_RECORD_LIST,
  WORK_CALENDAR_LIST,
  FREQUENCY_INFORMATION_LIST,
  PARTS_DELIVERY_LIST,
  ASSEMBLY_RECEIVING_GOODS_LIST,
  WAREHOUSE_ALLOCATION_PLAN_LIST,
  ALLOCATION_PLAN_LIST,
  MASTER_CONTROL_PLAN_LIST,
  INBOUND_EXECUTION_REPORT_LIST,
  UNSATISFACTORY_RECEIVING_LIST,
  UNSATISFACTORY_RECEIVING_DETAIL_LIST,
  WORK_CAPACITY_LIST,
  APPROVAL_PROCESS_LIST,
  STOCK_ATOM_REPORT_LIST,
  PLAN_DELIVERY_RATE_LIST,
  FINISHED_PRODUCTS_DELIVERY_RATE_LIST,
  MATERIAL_SHORTAGE_ASSEMBLY_CENTER_LIST,
  MANUAL_CALL_MATERIAL_LIST,
  RAW_MATERIAL_DELIVERY_RATE_LIST,
  OUTBOUND_DETAILS_LIST,
  MONTH_PLAN_POOL_LIST,
  INVENTORY_DETAILS_LIST,
  ESTATE_DAILY_PLAN_ANALYSIS_REPORT_LIST,
  INVENTORY_BALANCE_SPLIT_LIST,
  PLAN_POOL_REPORT_LIST,
  USER_LIST,
  POST_LIST,
  ROLE_LIST,
  BUSINESS_ORGANIZATION_LIST,
  CONFIG_LIST,
  NOTICE_LIST,
  DICT_LIST,
  LOOKUP_LIST,
  CODE_CONFIG_LIST,
  OPERATION_LOG_LIST,
  LOGIN_INFOR_LIST,
  RMS_MQ_LOG_LIST,
  ONLINE_LIST,
  GEN_LIST,
  CUTTING_BED_COST_ANALYSIS_REPORT_LIST
}
